import type {ChatState} from "./ChatState.js";
import {MessageFactory} from "../factory/MessageFactory.js";
import type {SessionItem} from "../session/SessionItem.js";
import {ref} from "vue";
import SSEClient from "../SSEComponent/SSEClient.js";
import {PredictSSEDataAdapter} from "../SSEComponent/PredictSSEDataAdapter.js";
import type {OnSSEConnectListener} from "../listener/OnSSEConnectListener.js";
import type {MessageStateMachine} from "./MessageStateMachine.js";

export class AgentState implements ChatState{

    constructor(private machine: MessageStateMachine) {}

    async handler(text: string, session: SessionItem) {

        const machine = this.machine
        const msg = ref(MessageFactory.createAiMsg())
        msg.value.isStreaming = true
        session.pushMessage(msg.value)

        const url = new URL("/api/mcframeAI/predict", window.location.origin)
        url.searchParams.set("question", text)

        const sseClient = new SSEClient(url)
        sseClient.registerAdapter(new PredictSSEDataAdapter(session))
        sseClient.registerConnectionListener(new class implements OnSSEConnectListener {
            onClose(): void {
                machine.isChatting = false
            }

            onSSEConnect(): void {
                machine.isChatting = true
            }

        })
        sseClient.connect()

    }

}